import { createApp } from 'vue'
import Currency from './Currency.vue'
import './assets/global.css'

createApp(Currency).mount('#currency')
